export default __webpack_public_path__ + "static/media/vehicle-crash-tree2.71deeb34.png";